import * as React from "react";
import { useSelector } from "react-redux";
import { getResolutionName } from "../../containers/WorkkardDetail/utils";
import LoaderComponent from "../Loader";
import UserImage from '../UserImage/index';
import "./reopenActList.scss";

const getUserDisplayName = (userList, userId) => {
  const user = userId != null ? userList?.[userId] : null;
  if (!user) return null;
  const firstName = user.firstName || user.first_name || '';
  const lastName = user.lastName || user.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim();
  return fullName || null;
};

const resolveDisplayName = (backendName, userList, userId) => {
  if (backendName && typeof backendName === 'string' && backendName.trim()) {
    return backendName.trim();
  }
  return getUserDisplayName(userList, userId) || 'NA';
};

const ReopenActList = (props) => {
  const userList = useSelector((state) => state.userList);
  const [closeActList, setCloseActList] = React.useState([]);
  // const { workkard, closeActivities } = useSelector(
  //   (state) => ({
  //     workkard: state.workkardDetail.workkardDetail,
  //   }),
  //   shallowEqual
  // );

  React.useEffect(() => {
    if (props.reopenActlist.length > 0) {
      setCloseActList(props.reopenActlist);
    } 
  }, []);

  // React.useEffect(() => {
  //   if (closeActivities.length > 0) setCloseActList(closeActivities);
  // }, [closeActivities]);

  const setReOpenActivity = (activityData) => {
    props.setReOpenActivity(activityData);
  };

  return (
    <div className="inner_container_Activity">
      <div className="component_ctr_area">
          {!closeActList.length > 0 ? (
            <LoaderComponent />
          ) : (
            <>
              <div className="stickyActivity sticky alignMiddle">
            <label>Please select an Activity</label>
                  <div className="activity_users">
                    <div className="user_block">
                      <span className="activity_creator">Owner</span>
                    </div>
                    <span className="sep_arrow"></span>
                    <div className="user_block">
                      <span className="activity_creator">Assignee</span>
                    </div>
                  </div>
                </div>
              <div className="inner_container_area">
                <ul className="open_activities_listing">
                  {closeActList.map((item, key) => {
                    const ownerName = resolveDisplayName(item.activityOwnerName, userList, item.activityOwnerId);
                    const assigneeName = resolveDisplayName(
                      item.activityAssigneeUserName || item.activityAssigneeName,
                      userList,
                      item.activityAssigneeId
                    );
                    return (
                      <li
                        className="open_activities_listing_item"
                        key={item.activityId}
                      >
                        <div
                          className="radio"
                          style={{
                            position: "absolute",
                            top: "-17px",
                            left: "-20px",
                          }}
                        >
                          <input
                            type="radio"
                            name="close_list"
                            className="gap"
                            id={"close_list_" + item.activityId}
                            onClick={() => setReOpenActivity(item)}
                          />
                          <label
                            htmlFor={"close_list_" + item.activityId}
                          ></label>
                        </div>
                        <div className="open_activities_summary">
                          <div class="activity_title">{item.activityName}</div>
                          <div className="activity_created_date">
                            &#8212; {item.createdDateString}
                          </div>
                          <span
                            className={`status assigned ${getResolutionName(
                              item.status.toLowerCase(),
                              true
                            )} ml`}
                          >
                            {getResolutionName(
                              item.status.toLowerCase(),
                              false
                            )}
                            {item.status === "In Progress" &&
                              " (" + "item.Progress" + "% DONE)"}
                          </span>
                          <div className="due_date_label ml">
                            due on{" "}
                            <span className="red">{item.dueDateString}</span>
                          </div>
                          <div className="activity_users">
                            <div className="user_block">
                              <UserImage profileUrl={item.activityOwnerImageUrl} size="24" profileName={ownerName} />
                              <span className="activity_creator">
                                {ownerName}
                              </span>
                            </div>
                            <span className="sep_arrow"></span>
                            <div className="user_block">
                              <UserImage profileUrl={item.activityAssigneeImageUrl} size="24" profileName={assigneeName} />
                              <span className="activity_creator">
                                {assigneeName}
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </>
          )}
      </div>
    </div>
  );
};
export default ReopenActList;
